module.exports = __webpack_public_path__ + "static/media/Crouch End Alcoves 4.6449baf8.jpg";